// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/Assets/fonts/DMSans_24pt-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/Assets/fonts/Satoshi-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/Assets/fonts/NotoSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/Assets/fonts/Roboto/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

@font-face {
  font-family: "DM Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: "Satoshi";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: "Noto Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.App-header {
  background-color: var(--neutral-dark-1);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: var(--link-primary);
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Default Classes */

.white-bg {
  background: var(--neutral-white);
}

.outlined-text {
  color: transparent;           /* Make the fill transparent */
  -webkit-text-stroke: 1px var(--neutral-white); /* Outline color and thickness */
  letter-spacing: 5px;           /* Center align the text in the div */
}
/* Non Prod Label Styles */
.non-prod-label {
  position: fixed;
  right: -35px;
  bottom: 150px;
  z-index: 9999;
  background: #e53935;
  color: #fff;
  font-size: 1rem;
  width: 100px;
  height: 30px;
  text-align: center;
  border-radius: 5px; 
  letter-spacing: 1px;
  transform: rotate(-90deg);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  -webkit-user-select: none;
          user-select: none;
  margin-right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,sBAAsB;EACtB,4CAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,4CAAoD;AACtD;;AAEA;EACE,wBAAwB;EACxB,4CAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,4CAA0D;AAC5D;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,oBAAoB;;AAEpB;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB,YAAY,8BAA8B;EAC5D,6CAA6C,EAAE,gCAAgC;EAC/E,mBAAmB,YAAY,qCAAqC;AACtE;AACA,0BAA0B;AAC1B;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n@font-face {\n  font-family: \"DM Sans\";\n  src: url(\"/public/Assets/fonts/DMSans_24pt-Regular.ttf\");\n}\n\n@font-face {\n  font-family: \"Satoshi\";\n  src: url(\"/public/Assets/fonts/Satoshi-Regular.otf\");\n}\n\n@font-face {\n  font-family: \"Noto Sans\";\n  src: url(\"/public/Assets/fonts/NotoSans-Regular.ttf\");\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"/public/Assets/fonts/Roboto/Roboto-Regular.ttf\");\n}\n\n.App-header {\n  background-color: var(--neutral-dark-1);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: var(--link-primary);\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Default Classes */\n\n.white-bg {\n  background: var(--neutral-white);\n}\n\n.outlined-text {\n  color: transparent;           /* Make the fill transparent */\n  -webkit-text-stroke: 1px var(--neutral-white); /* Outline color and thickness */\n  letter-spacing: 5px;           /* Center align the text in the div */\n}\n/* Non Prod Label Styles */\n.non-prod-label {\n  position: fixed;\n  right: -35px;\n  bottom: 150px;\n  z-index: 9999;\n  background: #e53935;\n  color: #fff;\n  font-size: 1rem;\n  width: 100px;\n  height: 30px;\n  text-align: center;\n  border-radius: 5px; \n  letter-spacing: 1px;\n  transform: rotate(-90deg);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n  user-select: none;\n  margin-right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
